import { Icon, Style } from "ol/style";
import { SelectedStatus } from "./enums";

import Pin from "../img/icons/pin.svg";
import Pin_CLICKED from "../img/icons/pin-selected.svg";

const images: Record<SelectedStatus, string> = {
  [SelectedStatus.Default]: Pin,
  [SelectedStatus.Selected]: Pin_CLICKED,
};

type SelectedStatusCache = Map<SelectedStatus, Style>;
const selectedStatusCache: SelectedStatusCache = new Map();

const ensureSymbol = (selectedStatus: SelectedStatus): void => {
  if (!selectedStatusCache.has(selectedStatus)) {
    const style = new Style({
      image: new Icon({
        src: images[selectedStatus],
        scale: 0.75,
        anchor: [0.5, 1],
      }),
    });
    selectedStatusCache.set(selectedStatus, style);
  }
};

export const getSymbol = (selectedStatus: SelectedStatus): Style => {
  ensureSymbol(selectedStatus);
  return selectedStatusCache.get(selectedStatus);
};

const clusterCache = new Map<number, Style>();
const ensureClusterSymbol = (count: number): void => {
  if (!clusterCache.has(count)) {
    clusterCache.set(
      count,
      new Style({
        image: new Icon({
          src: createImage(18, count, "#84BD01"),
          size: [36, 36],
        }),
      })
    );
  }
};
const createImage = function (radius, count, textColor) {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  canvas.width = radius * 2;
  canvas.height = radius * 2;

  // border
  ctx.beginPath();
  ctx.arc(radius, radius, 18, 0, 2 * Math.PI);
  ctx.fillStyle = "#acb7bf99";
  ctx.fill();

  // circle
  ctx.beginPath();
  ctx.arc(radius, radius, 18 - 3, 0, 2 * Math.PI);
  ctx.fillStyle = "#ffffff";
  ctx.fill();

  // text
  ctx.beginPath();
  ctx.font = "bold 14px sans-serif";
  ctx.fillStyle = textColor;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(count, radius, radius);

  return canvas.toDataURL();
};

export const getClusterSymbol = (count: number): Style => {
  ensureClusterSymbol(count);
  return clusterCache.get(count);
};
